<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;height: 100vh;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Reset Password </h3>
                                        <p class="custom-16px-400">Reset your account password</p>
                                    </div>
                                    <div class="mt-3">
                                        <strong class="text-left mt-2 mb-2">New Password</strong>
                                        <input type="password" class="custom-input-app mb-2" v-model="newPassword" />
                                    </div>
                                    <div class="mt-3">
                                        <strong class="text-left mt-2 mb-2">Confirm Password</strong>
                                        <input type="password" class="custom-input-app mb-2" v-model="confirmPassword" />
                                    </div>
                                    <div style="clear:both"></div>
                                    <div class="text-center mt-5">
                                        <span class="bg-453E8E custom-border-radius" v-on:click="ChangePassword">
                                                        <label class="ml-2 mr-2">Set New Password</label></span>
                                        <br />
                                        <label class="font-color-453E8E mt-4" @click="GoToLogin()">Back to Login</label>
                                    </div>
                                </CCard>
                            </CCol>
                        </div>
    
    
    
                    </CCol>

                    <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width:100px" src="../assets/img/success.png" />
                        <h3 class="custom-32px-500">Success!</h3>
                        <h3 class="custom-18px text-center">Your new passoword is succesfully created
                        </h3>
                    </div>
    
                </div>
            </div>
    
    
                </CRow>
            </CCol>
        </CCol>
    
       
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/all/banner.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            newPassword: "",
            confirmPassword: "",

            email: this.$route.query.email,
            code: this.$route.query.code,
            isPopupSuccess: false





        };
    },


    methods: {
        ChangePassword() {
      const formData = new FormData();

      formData.append("userEmail", this.$route.query.email);
       formData.append("code", this.verificationCode);
        formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.$router.push("/Login");
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
    GoToLogin()
        {
            this.$router.push("Login");
        }




    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
.c-header.c-header-fixed {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1029;
  background: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>